import { ReactComponent } from './number-6-xs.svg';
export const Number6IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-6-xs.js.map